export default __webpack_public_path__ + "static/media/icon_growth.63a0b14e.svg";